import { useState } from 'react'
import PropTypes from 'prop-types'
import { useFilters } from '../../contexts/FilterContext'
import FilterAttribute from './FilterAttribute'

function FilterGroup({ group }) {
  const { isGroupExpanded, toggleGroup } = useFilters()
  const [showAll, setShowAll] = useState(false)

  const isExpanded = isGroupExpanded(group.id)
  const displayAttributes = showAll
    ? group.attributes
    : group.attributes.slice(0, 4)
  const hasMoreAttributes = group.attributes.length > 4

  return (
    <div className="border-b border-gray-200 pb-4 mb-4 last:border-b-0 last:pb-0 last:mb-0">
      <button
        onClick={() => toggleGroup(group.id)}
        className="flex items-center justify-between w-full text-left"
      >
        <h4 className="text-sm font-medium text-gray-900">{group.name}</h4>
        <span className="text-gray-400">{isExpanded ? '−' : '+'}</span>
      </button>

      {isExpanded && (
        <div className="mt-3 space-y-3">
          {displayAttributes.map(attribute => (
            <FilterAttribute
              key={attribute.id}
              attribute={attribute}
              groupId={group.id}
            />
          ))}

          {hasMoreAttributes && (
            <button
              onClick={() => setShowAll(!showAll)}
              className="text-xs text-primary-500 hover:text-primary-700 font-medium"
            >
              {showAll
                ? 'Show less'
                : `Show ${group.attributes.length - 4} more...`}
            </button>
          )}
        </div>
      )}
    </div>
  )
}

FilterGroup.propTypes = {
  group: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    attributes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        type: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        length: PropTypes.number,
        slice: PropTypes.func,
      })
    ).isRequired,
  }).isRequired,
}

export default FilterGroup
